import React from 'react';
import { BlockLayoutProps } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';

import styles from './BaseBlockLayout.module.scss';
import ShadcnBaseBlockLayout from './ShadcnBaseBlockLayout';

function LegacyBaseBlockLayout(props: BlockLayoutProps) {
  return (
    <div
      className={[
        props.className,
        props.isContentDisabled ? styles.contentDisabled : ''
      ].join(' ')}
      onClick={props.onClick}
      style={props.backgroundColor ? { backgroundColor: props.backgroundColor } : {}}
      title={props.title}
      data-testid={props.testID}
    >
      {props.children}
    </div>
  );
}

export default function BaseBlockLayout(props: BlockLayoutProps) {
  const { isShadcnUiEnabled } = useFeatureToggleService();

  if (isShadcnUiEnabled()) {
    return <ShadcnBaseBlockLayout {...props} />;
  } else {
    return <LegacyBaseBlockLayout {...props} />;
  }
}

export function FormBlockLayout(props: BlockLayoutProps) {

  const classes = [
    props.className || '',
    'form-rows'
  ];
  return (
    <BaseBlockLayout
      className={classes.join(' ')}
      onClick={props.onClick}
      backgroundColor={props.backgroundColor}
      title={props.title}
      testID={props.testID}
      isContentDisabled={props.isContentDisabled}
    >
      {props.children}
    </BaseBlockLayout>
  );
}
